import { Box, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const WEATHER_STREAM_DEFS = [
    { key: 'temp', color: '#e74c3c', i18nKey: 'pages.dashboard.temperature' },
    { key: 'precipitation', color: '#003366', i18nKey: 'pages.dashboard.precipitation' },
    { key: 'snowfall', color: '#95a5a6', i18nKey: 'pages.dashboard.snowfall' },
    { key: 'wind', color: '#27ae60', i18nKey: 'pages.dashboard.wind' },
    { key: 'humidity', color: '#8e44ad', i18nKey: 'pages.dashboard.humidity' },
]

export default function WeatherFilters({ streams, onToggle }) {

    const { t } = useTranslation()

    return (
        <Box sx={{ mb: 2, p: 1.5, bgcolor: 'white', borderRadius: 1, boxShadow: '0 2px 4px rgba(0,0,0,0.08)' }}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {WEATHER_STREAM_DEFS.map(stream => (
                    <Chip
                        key={stream.key}
                        size="small"
                        avatar={
                            <Box sx={{
                                width: 10,
                                height: 10,
                                borderRadius: '50%',
                                bgcolor: stream.color,
                                ml: '4px !important'
                            }} />
                        }
                        label={t(stream.i18nKey)}
                        variant={streams.has(stream.key) ? 'filled' : 'outlined'}
                        onClick={() => onToggle(stream.key)}
                        sx={{
                            cursor: 'pointer',
                            ...(streams.has(stream.key) && {
                                bgcolor: '#e6ecf3',
                                borderColor: '#003366',
                            })
                        }}
                    />
                ))}
            </Box>
        </Box>
    )
}
